import React from "react";

const Skeleton = ({ width, height, radius }) => {
    return (
        <div
            className="skeleton-loader"
            style={{
                width: width || "100%",
                height: height || "20px",
                borderRadius: radius || "4px",
            }}
        />
    );
};

export default Skeleton;
